import React, { useState } from 'react';
import axios from 'axios';
import { Button } from '../ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { useToast } from '../../hooks/use-toast';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY_FORM = { name: '', email: '', phone: '', service: '', message: '' };
const FIELDS = [
  { name: 'name', type: 'text', placeholder: 'Your Name' },
  { name: 'email', type: 'email', placeholder: 'Email Address' },
  { name: 'phone', type: 'tel', placeholder: 'Phone Number' },
  { name: 'service', type: 'text', placeholder: 'Service Needed' },
];
const fieldClass = 'bg-gray-700 border-gray-600 text-white placeholder:text-gray-400 focus:border-yellow-400';

export const ContactForm = () => {
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toast } = useToast();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const { data } = await axios.post(`${API}/contact`, formData);
      toast({ title: 'Success!', description: data.message });
      setFormData(EMPTY_FORM);
    } catch {
      toast({ title: 'Error', description: 'Something went wrong. Please try again.', variant: 'destructive' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Card className="border border-gray-700 shadow-xl bg-gray-800">
      <CardHeader>
        <CardTitle className="text-white">Request a Free Estimate</CardTitle>
        <CardDescription className="text-gray-400">We'll respond within 24 hours</CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4" data-testid="contact-form">
          {FIELDS.map((field) => (
            <Input key={field.name} {...field} value={formData[field.name]} onChange={handleChange} required className={fieldClass} data-testid={`contact-${field.name}-input`} />
          ))}
          <Textarea name="message" placeholder="Tell us about your project..." rows={4} value={formData.message} onChange={handleChange} required className={fieldClass} data-testid="contact-message-input" />
          <Button type="submit" className="w-full bg-yellow-400 hover:bg-yellow-500 text-black font-bold shadow-lg" disabled={isSubmitting} data-testid="contact-submit-button">
            {isSubmitting ? 'Sending...' : 'Get Free Estimate'}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};
